import { render, staticRenderFns } from "./tHome.vue?vue&type=template&id=3e21b34c&scoped=true&"
import script from "./tHome.vue?vue&type=script&lang=js&"
export * from "./tHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e21b34c",
  null
  
)

export default component.exports